// extracted by mini-css-extract-plugin
export default {"account-settings-sidebar":"AccountSettingsSidebar_account-settings-sidebar__S5aiB","title":"AccountSettingsSidebar_title__EGqPP"};